import { number, object, string } from "yup";

const contactDataSchema = object({
  first_name: string().required("First name cannot be empty."),
  last_name: string().required("Last name cannot be empty."),
  email: string()
    .required("Email cannot be empty.")
    .email("The email is not a valid email address."),
  phone: object({
    code: string().required("Dialling code connot be empty."),
    number: number().required("Phone connot be empty."),
  }),
});

export default contactDataSchema;
